import { gql } from "graphql-request";

import { graphql } from "@/graphql/generated/gql";

// Authored with `gql` (not the codegen `graphql()` helper) so it works ahead of
// the next `pnpm codegen` run. Used by the forced-2FA setup flow (A2) to show
// the user's email while they hold only a 2fa_setup token (no access token).
export const getUserEmailForSetupQueryDocument = gql`
  query getUserEmailForSetup {
    getUserEmailForSetup
  }
`;

// ============== QUERIES ======================
export const getUser2FAStatusQueryDocument = graphql(/* GraphQL */ `
  query getUser2FAStatus {
    getUser2FAStatus {
      id
      userId
      isEnabled
      lastVerifiedAt
      createdAt
      updatedAt
    }
  }
`);

// ============== MUTATIONS ======================
export const generate2FASecretMutationDocument = graphql(/* GraphQL */ `
  mutation generate2FASecret {
    generate2FASecret {
      secret
      otpAuthUrl
    }
  }
`);

export const enable2FAMutationDocument = graphql(/* GraphQL */ `
  mutation enable2FA($input: Enable2FAInput!) {
    enable2FA(enable2FAInput: $input) {
      success
      backupCodes
    }
  }
`);

export const generate2FASecretForSetupMutationDocument = graphql(/* GraphQL */ `
  mutation generate2FASecretForSetup {
    generate2FASecretForSetup {
      secret
      otpAuthUrl
    }
  }
`);

export const enable2FAForSetupMutationDocument = graphql(/* GraphQL */ `
  mutation enable2FAForSetup($input: Enable2FAInput!) {
    enable2FAForSetup(enable2FAForSetupInput: $input) {
      status
      accessToken
      backupCodes
    }
  }
`);

export const disable2FAMutationDocument = graphql(/* GraphQL */ `
  mutation disable2FA($input: Disable2FAInput!) {
    disable2FA(disable2FAInput: $input)
  }
`);

export const regenerateBackupCodesMutationDocument = graphql(/* GraphQL */ `
  mutation regenerateBackupCodes($input: RegenerateBackupCodesInput!) {
    regenerateBackupCodes(regenerateBackupCodesInput: $input) {
      backupCodes
    }
  }
`);

export const verify2FACodeMutationDocument = graphql(/* GraphQL */ `
  mutation verify2FACode($input: Verify2FACodeInput!) {
    verify2FACode(verify2FACodeInput: $input) {
      token
    }
  }
`);

export const updateWorkspace2FARequirementMutationDocument = graphql(/* GraphQL */ `
  mutation updateWorkspace2FARequirement($input: UpdateWorkspace2FARequirementInput!) {
    updateWorkspace2FARequirement(updateWorkspace2FARequirementInput: $input) {
      id
      name
      workspaceUrl
      twoFactorAuth {
        id
        workspaceId
        isRequired
        createdAt
        updatedAt
      }
    }
  }
`);
